import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { MediaQueryBuilder } from '@app/core/services/common/styles/media-query-builder';
import { StyleService } from '@app/core/services/common/styles/style.service';
import { ContentManagerService } from '@app/modules/editor/services/content-manager.service';
import { EditorService } from '@app/modules/editor/services/editor.service';
import { ButtonSize, ButtonVariant } from '@app/modules/editor/shared/as-components/button/button.component';
import { CustomModalService } from '@app/modules/editor/shared/as-components/custom-modal/modal.service';
import * as EventEmitter from 'events';
import { cloneDeep } from 'lodash';
import { PageSettingsEditorComponent } from '../editor-top-panel/page-settings-editor/page-settings-editor.component';
import { LanguageChangeDialogComponent } from '../language-change-dialog/language-change-dialog.component';
import { BlockSlider, PageSeo, SeoTag, SliderSettingsAnimation, StructureContent } from '../models/content.model';

import {
  BackgroundColorData,
  InlineEdiotSliderSelectColorComponent,
} from './inline-edit-slider-select-color/inline-ediot-slider-select-color.component';

@Component({
  selector: 'inline-edit-slider',
  standalone: false,
  templateUrl: './inline-edit-slider.component.html',
  styleUrl: './inline-edit-slider.component.scss',
})
export class InlineEditSliderComponent implements OnInit {
  /** Aktualny język, np. 'PL' */
  @Input() lang = 'PL';

  /** Dostępne języki */
  @Input() languages = ['pl', 'en'];

  /** Wyemitujemy, gdy użytkownik potwierdzi zmianę języka */
  // @Output() langChange = new EventEmitter();

  /** Klik “zapisz i zostań” */
  @Output() saveAndStay = new EventEmitter();

  @ViewChild('editable', {read: ElementRef, static: false})
  editableDiv!: ElementRef<HTMLDivElement>;

  blockSlider: BlockSlider[] = [];

  selectedSlideIndex = 0;

  selectBlochSlider = '';

  menuOpen = false;

  blockStrckture: any;

  parentBlockStrukture: any;

  settingsParams: SliderSettingsAnimation = {
    sliderType: '',
    animationType: '',
    animationDelay: 0,
    animationDuration: 0,
  };

  typeSlider = [
    {value: 'default', name: 'Default'},
    {value: 'showcase', name: 'Showcase'},
    {value: 'carousel', name: 'Carousel'},
    {value: 'carousel3d', name: 'Carousel 3D'},
  ];

  animationSlider = [
    {value: 'fadeIn', name: 'Fade In'},
    {value: 'floatIn', name: 'Float In'},
  ];

  editorVisible = false;
  editTarget!: HTMLElement;
  editorTop = 0;
  editorLeft = 0;

  btnSize = ButtonSize;
  btnVariant = ButtonVariant;

  paramsPage: StructureContent;

  slideshowElem: HTMLElement;

  secondUidSlider = '';

  parentUid: string;

  pageSeo: PageSeo;

  currentLang = 'PL';

  value: any;

  seoTag: SeoTag;

  slides: any;

  onliTextHtml: HTMLElement;

  uploadProgress = 0;

  private lastLang = this.lang;

  constructor(
    // private dialog: MatDialog,
    public editorService: EditorService,
    private elRef: ElementRef,
    private contentManagerService: ContentManagerService,
    private cdr: ChangeDetectorRef,
    private modal: CustomModalService,
    private dialogRef: MatDialogRef<PageSettingsEditorComponent>,
    private route: ActivatedRoute,
    private styleService: StyleService,
    @Inject(MAT_DIALOG_DATA) public data: HTMLElement,
  ) {
    this.value = data.innerHTML;
    this.contentManagerService.getPageSettings().subscribe((pageParams) => {
      this.languages = pageParams.languages_list;
    });

    let el = data as HTMLElement;
    while (el && el.parentElement) {
      el = el.parentElement as HTMLElement;
      if (el.classList) {
        for (const className of Array.from(el.classList)) {
          if (className.startsWith('block_')) {
            this.parentUid = className;
            break;
          }
        }
        if (this.parentUid) break;
      }
    }
  }

  ngOnInit(): void {
    const classList = this.data.classList;
    this.secondUidSlider = classList[1];
    this.slideshowElem = this.data.querySelector(
      '.slideshow-container',
    ) as HTMLElement;
    const slideElements = Array.from(
      this.slideshowElem.getElementsByClassName('slides'),
    ) as HTMLElement[];
    this.slides = slideElements;
    if (this.slides.length > 0) {
      this.selectSlide(this.slides[0], 0);
    }
    this.setParamsView();
    this.createObjectSlider();
  }

  setParamsView() {
    this.settingsParams.sliderType = this.typeSlider.find(
      (e) => e.value == this.editorService.settingsSlider.sliderType,
    ).value;
    this.settingsParams.animationType = this.animationSlider.find(
      (e) => e.value == this.editorService.settingsSlider.animationType,
    ).value;
    this.settingsParams.animationDelay =
      this.editorService.settingsSlider.animationDelay;
    this.settingsParams.animationDuration =
      this.editorService.settingsSlider.animationDuration;
  }

  addSlide() {
    if (this.slides.length > 0) {
      const parentClass = this.slides[this.slides.length - 1] as HTMLElement;
      const className = parentClass.classList;
      this.updateBlockStyles(this.editorService.pageBlock.blocks, className[0]);
      const lastElement =
        this.parentBlockStrukture.specialBlock.children[0].children[0];
      const clone = cloneDeep(lastElement);
      clone.styles.all.basic.backgroundImage = '';
      const random4 = Math.floor(1000 + Math.random() * 9000);
      clone.uId = clone.uId + random4;
      this.parentBlockStrukture.specialBlock.children[0].children.push(clone);
      const page = this.editorService.pageBlock;
      const blocksStyles = MediaQueryBuilder.build(page.blocks);
      StyleService.bodyStyles.push(blocksStyles);
      this.styleService.setStyles();
      const newSlide = parentClass.cloneNode(true) as HTMLElement;
      const element = newSlide.firstElementChild as HTMLElement;
      element.className = clone.uId + ' visibleOnViewport';
      this.blockSlider.push({
        uId: clone.uId,
        backgroundImage: clone.styles.all.basic.backgroundImage,
        backgroundColor: clone.styles.all.basic.backgroundColor,
      });
      this.slides.push(newSlide);
    }
  }

  createObjectSlider() {
    this.blockSlider = [];
    this.slides.forEach((e: HTMLElement) => {
      const firstChild = e.firstElementChild as HTMLElement;
      if (firstChild) {
        const className = firstChild.classList;
        this.updateBlockStyles(
          this.editorService.pageBlock.blocks,
          className[0],
        );
        const block = {
          uId: className[0],
          backgroundColor: this.blockStrckture.styles.all.basic.backgroundColor,
          backgroundImage: this.blockStrckture.styles.all.basic.backgroundImage,
        } as BlockSlider;
        this.blockSlider.push(block);
      }
    });
  }

  selectSlide(slide: HTMLElement, index: number) {
    this.selectedSlideIndex = index;
    this.selectBlochSlider = slide.outerHTML;

    const slideEl = this.slides[this.selectedSlideIndex] as HTMLElement;
    if (!slideEl) {
      return;
    }
    const spanNodeList = slideEl.querySelectorAll(
      'span',
    ) as NodeListOf<HTMLSpanElement>;

    // a dalej jak poprzednio:
    const wrapper = document.createElement('div');
    spanNodeList.forEach((span) => wrapper.appendChild(span.cloneNode(true)));
    this.onliTextHtml = wrapper;
  }

  onEdit() {
    console.log('slide');
  }

  previewSlide(slide: any) {
    alert('Podgląd slajdu: ' + slide.id);
  }

  copySlide(index: number) {
    if (this.slides.length > 0) {
      const parentClass = this.slides[index] as HTMLElement;
      const className = parentClass.classList;
      this.updateBlockStyles(this.editorService.pageBlock.blocks, className[0]);
      const lastElement =
        this.parentBlockStrukture.specialBlock.children[0].children[index];
      const clone = cloneDeep(lastElement);
      const random4 = Math.floor(1000 + Math.random() * 9000);
      clone.uId = clone.uId + random4;
      this.parentBlockStrukture.specialBlock.children[0].children.push(clone);
      const page = this.editorService.pageBlock;
      const blocksStyles = MediaQueryBuilder.build(page.blocks);
      StyleService.bodyStyles.push(blocksStyles);
      this.styleService.setStyles();
      const newSlide = parentClass.cloneNode(true) as HTMLElement;
      const element = newSlide.firstElementChild as HTMLElement;
      element.className = clone.uId + ' visibleOnViewport';
      this.blockSlider.push({
        uId: clone.uId,
        backgroundImage: clone.styles.all.basic.backgroundImage,
        backgroundColor: clone.styles.all.basic.backgroundColor,
      });
      this.slides.push(newSlide);
    }
  }

  removeSlide(index: any) {
    const parentClass = this.slides[index].firstElementChild as HTMLElement;
    const className = parentClass.classList[0];
    this.slides = this.slides.filter((s) => s !== this.slides[index]);
    this.blockSlider = this.blockSlider.filter((x) => x.uId !== className);
  }

  onLanguageSelect(ev: any) {
    const next = ev?.value ? ev?.value : (ev as string);
    if (this.contentManagerService.hasUnsavedChanges()) {
      this.currentLang = next.toUpperCase();
      return;
    }
    const ref = this.modal.open(LanguageChangeDialogComponent, {
      width: '600px',
      height: '232px',
      data: {nextLang: next},
      disableClose: false,
    });
    ref.afterClosed().subscribe((result) => {
      switch (result.action) {
        case 'save-change':
          this.save();
          this.currentLang = next.toUpperCase();
          this.lastLang = next;
          break;
        case 'change':
          this.applyLang(next);
          this.lastLang = next;
          break;
        default:
          this.revertLang();
      }
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save() {
    this.contentManagerService.setSlider(this.blockSlider, this.parentUid);
    this.saveSettings();
    this.dialogRef.close();
  }

  saveSettings() {
    this.contentManagerService.setSliderSettings(
      this.secondUidSlider,
      this.settingsParams,
    );
  }

  updateBlockSliderParams(uId: string, newParams: BlockSlider) {
    const index = this.blockSlider.findIndex((e) => e.uId === uId);
    if (index !== -1) {
      this.blockSlider[index] = newParams;
    }
  }

  applyLang(next) {
    this.currentLang = next;
    console.log('applyLang');
  }

  revertLang() {
    console.log('revertLang');
  }

  replaceImage(files: FileList): void {
    const file = files.item(0);
    if (!file) return;

    const originalSlide = this.slides[this.selectedSlideIndex] as HTMLElement;

    const imgEl = originalSlide.querySelector('img') as HTMLImageElement | null;
    const block = originalSlide.querySelector(
      '[class*="block_"]',
    ) as HTMLElement | null;

    const oldUrl = imgEl
      ? imgEl.src
      : block
        ? getComputedStyle(block).backgroundImage.match(/url\("(.*)"\)/)?.[1] ??
        ''
        : '';

    this.contentManagerService
      .uploadMedia(
        file,
        {
          updateMediaIds: true,
          onSuccess: (response) => {
            const newUrl = response.fullUrl;
            if (!newUrl) return;
            const clonedSlide = originalSlide.cloneNode(true) as HTMLElement;
            const clonedImg = clonedSlide.querySelector(
              'img',
            ) as HTMLImageElement | null;
            if (clonedImg) clonedImg.src = newUrl;
            const clonedBlock = clonedSlide.querySelector(
              '[class*="block_"]',
            ) as HTMLElement | null;
            if (clonedBlock)
              clonedBlock.style.backgroundImage = `url(${newUrl})`;

            this.slides[this.selectedSlideIndex] = clonedSlide;
            this.selectBlochSlider = clonedSlide.outerHTML;

            // this.getblockpage(newUrl, oldUrl);
            this.updateBlockStyles(
              this.editorService.pageBlock.blocks,
              block.classList[0],
              'url',
              newUrl,
            );
            this.cdr.detectChanges();
          },
        },
        (progress) => (this.uploadProgress = progress),
      )
      .subscribe({
        error: (err) => console.error(err),
      });
  }

  openBackgroundColorEditor() {
    const originalSlide = this.slides[this.selectedSlideIndex] as HTMLElement;
    const block = originalSlide.querySelector<HTMLElement>('[class*="block_"]');

    this.updateBlockStyles(
      this.editorService.pageBlock.blocks,
      block.classList[0],
    );
    const computed = this.blockStrckture?.styles?.all?.basic?.backgroundColor;

    const dialogRef = this.modal.open(InlineEdiotSliderSelectColorComponent, {
      width: '300px',
      data: {color: computed} as BackgroundColorData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.action === 'save') {
        const newColor = result.color as string;
        const clonedSlide = originalSlide.cloneNode(true) as HTMLElement;
        const clonedBlock =
          clonedSlide.querySelector<HTMLElement>('[class*="block_"]');
        if (clonedBlock) {
          clonedBlock.style.backgroundColor = newColor;
        }
        this.slides[this.selectedSlideIndex] = clonedSlide;
        this.selectBlochSlider = clonedSlide.outerHTML;

        this.updateBlockStyles(
          this.editorService.pageBlock.blocks,
          block.classList[0],
          'color',
          result.color,
        );
        this.cdr.detectChanges();
      }
    });
  }

  updateBlockStyles(blocks, targetUid: string, key?: string, params?: string) {
    for (const blk of blocks) {
      if (blk.uId === targetUid) {
        this.blockStrckture = blk;
        if (key === 'color') {
          if (blk.styles && blk.styles.all && blk.styles.all.basic) {
            blk.styles.all.basic.backgroundColor = params;
            const page = this.editorService.pageBlock;
            const blocksStyles = MediaQueryBuilder.build(page.blocks);
            StyleService.bodyStyles.push(blocksStyles);
            this.styleService.setStyles();
            this.updateBlockSliderParams(blk.uId, {
              uId: blk.uId,
              backgroundImage: blk.styles.all.basic.backgroundImage,
              backgroundColor: blk.styles.all.basic.backgroundColor,
            });
          }
        } else if (key === 'url') {
          blk.styles.all.basic.backgroundImage = `url(${params})`;
          const page = this.editorService.pageBlock;
          const blocksStyles = MediaQueryBuilder.build(page.blocks);
          StyleService.bodyStyles.push(blocksStyles);
          this.styleService.setStyles();
          this.updateBlockSliderParams(blk.uId, {
            uId: blk.uId,
            backgroundImage: blk.styles.all.basic.backgroundImage,
            backgroundColor: blk.styles.all.basic.backgroundColor,
          });
        }
        return blk;
      }
      if (blk.children && blk.children.length > 0) {
        if (this.updateBlockStyles(blk.children, targetUid, key, params)) {
          this.parentBlockStrukture = blk;
          return true;
        }
      }
      if (blk.specialBlock?.children && blk.specialBlock.children.length > 0) {
        if (
          this.updateBlockStyles(
            blk.specialBlock.children,
            targetUid,
            key,
            params,
          )
        ) {
          this.parentBlockStrukture = blk;
          return true;
        }
      }
    }
    return false;
  }

  dropSlide(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }

    moveItemInArray(this.slides, event.previousIndex, event.currentIndex);
    moveItemInArray(this.blockSlider, event.previousIndex, event.currentIndex);
    if (this.selectedSlideIndex === event.previousIndex) {
      this.selectedSlideIndex = event.currentIndex;
    } else if (
      this.selectedSlideIndex >
      Math.min(event.previousIndex, event.currentIndex) &&
      this.selectedSlideIndex <=
      Math.max(event.previousIndex, event.currentIndex)
    ) {
      this.selectedSlideIndex +=
        event.previousIndex > event.currentIndex ? 1 : -1;
    }
    this.createObjectSlider();

    this.cdr.detectChanges();
  }

  handleTextClick(ev: MouseEvent): void {
    const el = ev.target as HTMLElement;
    if (el.closest('.text-editor')) {
      return;
    }
    const clickable = el.closest('span');
    if (clickable) {
      ev.stopPropagation();
      this.openEditor(ev, clickable as HTMLElement);
    } else {
      this.hideEditor();
    }
  }

  // === otwarcie edytora ===
  openEditor(ev: MouseEvent, element: HTMLElement): void {
    this.editTarget = element;
    const rect = element.getBoundingClientRect();

    this.editorLeft = rect.left + rect.width / 2 + window.scrollX;
    this.editorTop = rect.top;
    this.editorVisible = true;
    this.cdr.detectChanges();
  }

  // === zapis zmian z wewnętrznego komponentu ===
  onContentSaved(updated: HTMLElement): void {
    this.contentManagerService.processHtmlElement(updated);
    this.hideEditor();
  }

  // === zamknięcie edytora bez zapisu (np. Esc) ===
  hideEditor(): void {
    this.editorVisible = false;
  }
}
